module.exports = __webpack_public_path__ + "static/image4-fd7ace582c74db1f1fb0e8e092b8c827.jpg";